import React from 'react'

const MyBlock = ({ children }) => {
  return (
    <div className='myBlock'>
        { children }
    </div>
  )
}

export default MyBlock